<template>
	<div
		class="p-px duration-300 border-2 rounded-lg cursor-pointer"
		@click="emit('update:modelValue', !modelValue)"
		:class="{
			'border-transparent bg-primary': modelValue,
			'border-black bg-transparent': !modelValue
		}"
	>
		<span
			class="flex w-full h-full m-0 text-white duration-300 transform"
			:class="{
				'opacity-100 scale-100': modelValue,
				'opacity-0 scale-50': !modelValue
			}"
		>
			<Icon name="mdi:check" class="w-full h-full" />
		</span>
	</div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	"update:modelValue": [boolean]
}>()
const props = defineProps<{
	modelValue?: boolean
}>()
</script>
